import PressArmorLogo from "../../../../src/images/services/pressarmor.svg";
import * as React from 'react';
export default {
  PressArmorLogo,
  React
};